import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { APP_BASE_HREF } from "@angular/common";
import { Constants } from "../../shared/Constants";
import { Piece } from "../../models/piece";
import { Observable } from "rxjs";

@Injectable()
export class PieceService {
  constructor(private http: HttpClient) {}

  getArticulos(idListProduct: number) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.get(
      Constants.URL_BACKEND + `/piece-articulo/${idListProduct}`,
      {
        headers: headers,
      }
    );
  }

  getArticulosPorListaYMedio(idListProduct: number, idMedio: number) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.get(
      Constants.URL_BACKEND + `/piece-articulo-medio/${idListProduct}/${idMedio}`,
      {
        headers: headers,
      }
    );
  }

  savePiece(piece: Piece) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.post(Constants.URL_BACKEND + "/piece", piece, { headers });
  }

  updatePiece(id: number, piece: Piece) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.put(Constants.URL_BACKEND + `/piece/${id}`, piece, {
      headers,
    });
  }

  getAllByWorkOrderId(workOrderId: number): Observable<Piece[]> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.get<Piece[]>(
      Constants.URL_BACKEND + `/piece-work-order/${workOrderId}`,
      { headers }
    );
  }

  deletePiece(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.delete(Constants.URL_BACKEND + "/piece/" + id, {
      headers,
    });
  }

  getExcelReport(workOrderId: number, params?: { fechaInicio?: string, fechaFinal?: string }): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set(
      'Authorization',
      'Basic ' + btoa(localStorage.getItem('jwt'))
    );

    let url = Constants.URL_BACKEND + '/piece-excel/' + workOrderId;
    const optionArgs = {
      headers: headers,
      responseType: 'blob' as 'json'
    }

    if (params) {
      if (params.fechaInicio && !params.fechaFinal) {
        url = url + `?fechaInicio=${params.fechaInicio}`
      }

      if (!params.fechaInicio && params.fechaFinal) {
        url = url + `?fechaFinal=${params.fechaFinal}`
      }

      if (params.fechaInicio && params.fechaFinal) {
        url = url + `?fechaInicio=${params.fechaInicio}&fechaFinal=${params.fechaFinal}`
      }

    }

    return this.http.get(url , optionArgs);
  }

  getExcelReportByClientAndParams(clientId: number, params?: {fechaInicio?: string, fechaFinal?: string}):Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set(
      'Authorization',
      'Basic ' + btoa(localStorage.getItem('jwt'))
    );

    let url = Constants.URL_BACKEND + '/piece-excel-client/' + clientId;
    const optionArgs = {
      headers: headers,
      responseType: 'blob' as 'json'
    }

    if (params) {
      if (params.fechaInicio && !params.fechaFinal) {
        url = url + `?fechaInicio=${params.fechaInicio}`
      }

      if (!params.fechaInicio && params.fechaFinal) {
        url = url + `?fechaFinal=${params.fechaFinal}`
      }

      if (params.fechaInicio && params.fechaFinal) {
        url = url + `?fechaInicio=${params.fechaInicio}&fechaFinal=${params.fechaFinal}`
      }

    }

    return this.http.get(url , optionArgs);
  }

}



// WEBPACK FOOTER //
// ./src/app/system/services/piece.service.ts